import application from 'application/application';

const controller = 'DefaultSubMenuController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'helper',
	'API',
	'authentication',
	'$location',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		helper,
		API,
		authentication,
		$location
	) => {
		// $scope.submenuOptions = {
		// 	title: 'Minha conta',
		// 	exitButton: true,
		// 	links: [
		// 		{
		// 			name: 'Informações',
		// 			url: 'informations',
		// 			id: 'informacoes',
		// 			sref: 'root.default.account.info',
		// 			active: 'active'
		// 		},
		// 		{
		// 			name: 'Grupos',
		// 			url: 'group',
		// 			id: 'grupos',
		// 			sref: 'root.default.account.group',
		// 			active: 'active'
		// 		},
		// 		{
		// 			name: 'Notificações',
		// 			url: 'notifications',
		// 			id: 'notificacoes',
		// 			sref: 'root.default.account.notifications',
		// 			active: 'active'
		// 		},
		// 		{
		// 			name: 'Integrações',
		// 			url: 'integrations',
		// 			id: 'integracoes',
		// 			sref: 'root.default.account.integrations',
		// 			active: 'active'
		// 		},
		// 		{
		// 			name: 'Central de Pagamentos',
		// 			url: 'payments',
		// 			id: 'central-de-pagamentos',
		// 			href: 'https://pagamentos.advise.com.br',
		// 			active: 'active'
		// 		},
		// 		{
		// 			name: 'Meus Recursos',
		// 			url: 'resources',
		// 			id: 'meus-recursos',
		// 			sref: 'root.default.account.resources',
		// 			active: 'active'
		// 		}
		// 	]
		// };

		// $scope.recordClient = () => {
		// 	$http({
		// 		...helper.http(API.customers, 'GET'),
		// 		params: {
		// 			...helper.httpFields(['possuiGrupo']),
		// 			IDs: authentication.getUserData('idCliente')
		// 		}
		// 	}).then(response => {
		// 		if (response.data.itens[0].possuiGrupo) {
		// 			$http({
		// 				...helper.http(API.groupUsers, 'GET'),
		// 				params: {
		// 					...helper.httpFields([
		// 						'ListaUsuariosGrupo.IdUsuarioXGrupo, ListaUsuariosGrupo.IdUsuarioCliente, ListaUsuariosGrupo.administrador'
		// 					]),
		// 					IdsSituacaoGrupoUsuario: [-1, -2],
		// 					paginaAtual: 1,
		// 					registrosPorPagina: 1
		// 				}
		// 			}).then(res => {
		// 				let usersList =
		// 					(res.data.itens[0] && res.data.itens[0].listaUsuariosGrupo) || [];

		// 				let adminList = usersList.filter(
		// 					user =>
		// 						user.idUsuarioCliente ==
		// 							JSON.parse(localStorage.getItem('__authenticationUserData__'))
		// 								.idUsuarioCliente && user.administrador
		// 				);

		// 				$http({
		// 					...helper.http(API.usersCustomers, 'GET'),
		// 					params: {
		// 						...helper.httpFields(['usuarioAdministrador']),
		// 						IDs: JSON.parse(
		// 							localStorage.getItem('__authenticationUserData__')
		// 						).idUsuarioCliente
		// 					}
		// 				})
		// 					.then(res => {
		// 						$scope.isUserAdmin = res.data.itens[0].usuarioAdministrador;
		// 					})
		// 					.finally(() => {
		// 						$rootScope.hasGroup =
		// 							adminList.length > 0 || $scope.isUserAdmin;
		// 					});
		// 			});
		// 		} else {
		// 			$rootScope.hasGroup = false;
		// 		}
		// 	});
		// };

		$scope.groupPermissions = JSON.parse(
			localStorage.getItem('_allowedGroup_')
		);

		$scope.currentPageUrl = () => {
			if ($location.$$url.split('/')[1] == 'cadastrar-processos-automaticos') {
				return 'cadastrar-processos-automaticos';
			}

			return $location.$$url.split('/')[2];
		};

		$scope.verifyActiveFont = id => {
			if (!id) {
				id = $scope.currentPageUrl();
			}

			$rootScope.activeInfo = false;
			$rootScope.activeGrupo = false;
			$rootScope.activeConfig = false;
			$rootScope.activeAten = false;
			$rootScope.activeRec = false;
			$rootScope.activeAddAutoProcess = false;

			switch (id) {
				case 'informacoes':
				case 'info':
					$rootScope.activeInfo = true;
					break;
				case 'configuracoes':
				case 'config':
					$rootScope.activeConfig = true;
					break;
				case 'atendimento':
					$rootScope.activeAten = true;
					break;
				case 'addAutomaticProcesses':
				case 'cadastrar-processos-automaticos':
					$rootScope.activeAddAutoProcess = true;
					break;
			}
		};

		$scope.verifyActiveFont();

		$scope.verifyPasteAccount = id => {
			const url = $scope.currentPageUrl();

			if (id === 'info' && url !== 'informacoes') {
				$state.go('root.default.account.info', { inherit: false });
				$scope.verifyActiveFont(id);
			} else if (id === 'config' && url !== 'configuracoes') {
				$state.go('root.default.account.config', { inherit: false });
				$scope.verifyActiveFont(id);
			} else if (id === 'atendimento' && url !== 'atendimento') {
				$state.go('root.default.account.atendimento', { inherit: false });
				$scope.verifyActiveFont(id);
			} else if (
				id === 'addAutomaticProcesses' &&
				url !== 'cadastrar-processos-automaticos'
			) {
				const newTabUrl = $state.href(
					'root.default.addAutomaticProcesses',
					{},
					{ absolute: true }
				);

				window.open(newTabUrl, '_blank');
			}
		};
	}
]);

export default controller;
